import PREMIUM_CHANGE from '../../features/premium-change/constants';

const getFutureDate = (useFutureEffectiveDate: boolean | undefined) =>
  useFutureEffectiveDate ? PREMIUM_CHANGE.FUTURE_EFFECTIVE_DATE : null;

export default getFutureDate;
